import type { Item } from "../../../http/types/items";

// Connectors, supports and screws: the options picked by their item.
type ItemOption = { item: Item };

export const getItemOptionLabel = (option: ItemOption): string => `${option.item.code} - ${option.item.description}`;

export const getOptionsByItemId = <T extends ItemOption>(options: T[] | null | undefined): ReadonlyMap<string, T> =>
  new Map(options?.map((option) => [option.item.id, option]));

// The offered option matching the field's value - null once it isn't offered anymore - so a select
// shows the option list's own object rather than the (possibly saved) value.
export const getOfferedOption = <T extends ItemOption>(
  optionsByItemId: ReadonlyMap<string, T>,
  value: ItemOption | null | undefined,
): T | null => (value ? (optionsByItemId.get(value.item.id) ?? null) : null);
